import React from "react";
import "./footer.css";
import gpt3Logo from "../../assets/logo.svg";

const Footer = () => {
  return (
    <div className="gpt3__footer section__padding">
      <div className="gpt3__footer-heading">
        <h1 className="gradient__text">
          Do you want to step in to the future before others
        </h1>
      </div>
      <div className="gpt3__footer-btn">
        <p>Request Early Access</p>
      </div>
      <div className="gpt3__footer-links">
        <div className="gpt3__footer-links_logo">
          <img src={gpt3Logo} alt="Logo" />
          <p>Sector-62, Noida, Uttar-Pradesh, All Rights Reserved</p>
        </div>
        <div className="gpt3__footer-links_div">
          <h4>Links</h4>
          <p>Overons</p>
          <p>Overons</p>
          <p>Overons</p>
          <p>Overons</p>
        </div>
        <div className="gpt3__footer-links_div">
          <h4>Company</h4>
          <p>Overons</p>
          <p>Overons</p>
          <p>Overons</p>
          <p>Overons</p>
        </div>
        <div className="gpt3__footer-links_div">
          <h4>Get In Touch</h4>
          <p>Overons</p>
          <p>Overons</p>
          <p>Overons</p>
          <p>Overons</p>
        </div>
      </div>
      <div className="gpt3__footer-copyright">
        <p>&copy; Copyright 2023, All rights reserved</p>
        <p>
          Built with &#x2661; by <a href="#">Rohit Pandey</a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
